const bladeSides = [
  {
    key: 'LeadingEdge',
    value: 'Leading Edge'
  },
  {
    key: 'PressureSide',
    value: 'Pressure Side'
  },
  {
    key: 'SuctionSide',
    value: 'Suction Side'
  },
  {
    key: 'TrailingEdge',
    value: 'Trailing Edge'
  }
];
export const blades = [
  {
    position: 'A',
    sides: bladeSides
  },
  {
    position: 'B',
    sides: bladeSides
  },
  {
    position: 'C',
    sides: bladeSides
  }
];
